import script from "./section-desc.vue?vue&type=script&setup=true&lang=ts"
export * from "./section-desc.vue?vue&type=script&setup=true&lang=ts"

import "./section-desc.vue?vue&type=style&index=0&id=d5365242&scoped=true&lang=css"

import exportComponent from "G:\\Coding_Projects\\cv2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d5365242"]])

export default __exports__